<template>
    <v-row>
        <v-col cols="4">
            <v-select variant="outlined" :items="type" return-object v-model="typeValue"></v-select>
        </v-col>
        <v-col>
            <v-text-field :rules="rules" @keypress="validation.input.isIdentity($event, typeValue.value)"
                variant="outlined" :placeholder="$t('customer-info.general.input.identity-card.title')"
                v-model="identityValue" :counter="maxLength" :maxlength="maxLength">
            </v-text-field>
        </v-col>
    </v-row>
</template>

<script setup>
import validation from "@/utils/validation";
import { computed, defineModel, defineProps, ref, watch } from "vue"
const type = [
    {
        title: "KTP",
        value: "ktp"
    },
    {
        title: "SIM",
        value: "sim"
    },
    {
        title: "PASSPORT",
        value: "passport"
    }
]
const typeValue = ref(type[0])
const identityValue = ref("")

watch(typeValue, () => {
    identityValue.value = ""
})

const modelValue = defineModel({
    required: true,
    type: Array,
    default: ["ktp", ""]
})

const answer = computed(() => {
    return [typeValue.value?.value, identityValue.value]
})

watch(answer, (value) => {
    modelValue.value = value
})

const props = defineProps({
    required: {
        type: Boolean,
        default: () => {
            return false
        },
        required: false
    }
})

const maxLength = computed(() => {
    let value = 0
    switch (typeValue.value.value) {
        case 'ktp': {
            value = 16
            break
        }
        case 'sim': {
            value = 14
            break
        }
        case 'passport': {
            value = 15
            break
        }
    }

    return value
})

const rules = computed(() => {
    const defaultRules = [
        (v) => {
            return !props.required || !!v || "Silahkan isi bagian ini"
        }
    ]

    if (props.required || identityValue.value.length > 0)
        switch (typeValue.value.value) {
            case "ktp": {
                const pattern = /^(1[1-9]|21|[37][1-6]|5[1-3]|6[1-5]|[89][12])\d{2}\d{2}([04][1-9]|[1256][0-9]|[37][01])(0[1-9]|1[0-2])\d{2}\d{4}$/

                defaultRules.push((v) => {
                    return v.match(pattern) || "Nomor KTP tidak valid"
                })

                break
            }
            case "sim": {
                const pattern = /^\d{14}$/

                defaultRules.push((v) => {
                    return v.match(pattern) || "Nomor SIM tidak valid"
                })

                break
            }
            case "passport": {
                break
            }
        }

    return defaultRules
})
</script>